module.exports = __webpack_public_path__ + "images/subscription-icons-nomembershipfee.svg";